/* yourtheone — セット/単品 購入タイプ切替（yt-bundle-nav / DQ-017）
 * データは3商品分離のまま、セットPDP上で単品商品のバリアントを /cart/add.js で追加する。
 * - セットタブ: ネイティブの variant picker / product form をそのまま使う
 * - 単品タブ: ネイティブUIを隠し（.yt-bundle-mode-single）、単品パネルからカート追加
 * - カート再描画: cart-drawer / cart-notification の getSectionsToRender + renderContents（Dawn準拠）
 * vanilla JS / アニメーションはCSS側のみ（prefers-reduced-motion 対応済み）。
 */
(function () {
  'use strict';

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-yt-bundle-nav]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  function init(el) {
    if (el.dataset.ytBundleInit === 'true') return;
    el.dataset.ytBundleInit = 'true';

    var productInfo = el.closest('product-info');
    var tabs = el.querySelectorAll('[data-yt-tab]');
    var panels = el.querySelectorAll('[data-yt-panel]');

    function select(key) {
      var i;
      for (i = 0; i < tabs.length; i++) {
        var selected = tabs[i].getAttribute('data-yt-tab') === key;
        tabs[i].setAttribute('aria-selected', selected ? 'true' : 'false');
        tabs[i].tabIndex = selected ? 0 : -1; /* roving tabindex（ARIA tabsパターン） */
      }
      for (i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-yt-panel') !== key;
      }
      if (productInfo) {
        productInfo.classList.toggle('yt-bundle-mode-single', key !== 'set');
      }
    }

    /* 矢印キー操作（Left/Right/Home/End・自動アクティベーション） */
    function onKeydown(event, index) {
      var last = tabs.length - 1;
      var next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      select(tabs[next].getAttribute('data-yt-tab'));
      tabs[next].focus();
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab.getAttribute('data-yt-tab'));
        });
        tab.addEventListener('keydown', function (event) {
          onKeydown(event, index);
        });
      })(tabs[t], t);
    }

    for (var p = 0; p < panels.length; p++) {
      setupPanel(panels[p]);
    }
  }

  function setupPanel(panel) {
    var btn = panel.querySelector('[data-yt-add]');
    var err = panel.querySelector('[data-yt-error]');
    if (!btn) return;

    var radios = panel.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () {
        hideError(err);
      });
    }

    btn.addEventListener('click', function () {
      var checked = panel.querySelector('input[type="radio"]:checked');
      if (!checked) {
        showError(err, 'サイズを選択してください。');
        return;
      }
      addToCart(Number(checked.value), btn, err);
    });
  }

  function showError(err, msg) {
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  function hideError(err) {
    if (!err) return;
    err.hidden = true;
  }

  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToCart(variantId, btn, err) {
    var cart = cartElement();
    var body = { id: variantId, quantity: 1 };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    hideError(err);
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        if (parsed.status) {
          showError(err, parsed.description || parsed.message || 'カートに追加できませんでした。');
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(parsed);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'yt-bundle-nav',
            productVariantId: variantId,
            cartData: parsed
          });
        }
      })
      .catch(function () {
        showError(err, 'カートに追加できませんでした。時間をおいて再度お試しください。');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
